import React from "react";
import SFIcon from "@/custom_components/SFIcon/SFIcon";
import { helpIconFor } from "./helpIcons";
import classes from "./Help.module.css";

/**
 * Section heading for one `iconId` group — the icon chip is the whole point of
 * the iconId field, so it leads.
 */
const HelpGroupHeader = ({ iconId, label, count }) => (
  <div className={classes.groupHead}>
    <span className={classes.iconChip}>
      <SFIcon name={helpIconFor(iconId)} size={15} />
    </span>
    <span className={classes.groupLabel}>{label}</span>
    <span className={classes.groupCount}>{count}</span>
  </div>
);

export default HelpGroupHeader;
